<po-page-list p-title="Consulta cadastro de clientes" [p-filter]="filter">
  <!-- Botão para o pré-cadastro -->
  <div class="po-m-5" style="text-align: right;">
    <po-button p-label="Pré-Cadastro" (p-click)="onClick()" p-type="primary">
    </po-button>
  </div>

 
  <po-table
    p-sort="true"  
    p-container="light"  
    [p-columns]="columns"  
    [p-items]="clientesList"  
    [p-loading]="loading"  
    [p-actions]="actions" 
    p-container="shadow"  
    p-height="300" 
    p-striped="true" 
  >
  </po-table>
</po-page-list>
